import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  DatePickerInput,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import styles from "./Screen1.module.css";
import addImg from "../../../../assets/addImg.png";
import img from "../../../../assets/staticImages/photoimg1.png";
import dummy from "../../../../assets/dummy.jpg";
import dots from "../../../../assets/pfdots.png";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import dayjs from "dayjs";
import moment from "moment";
import { DotsIcon } from "../../../../components/icons/Icons";
const Screen1 = ({ setCurrentStep }) => {
  // console.log("screeenn1", profileImg);
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);

  const [date, setdate] = useState(
    WeddingWeb?.welcome?.date ? dayjs(WeddingWeb.welcome.date) : null
  );
  const [description, setDescription] = useState(
    WeddingWeb?.welcome?.description
  );
  const [save, setSave] = useState(WeddingWeb.welcome);
  const [profileImg, setProfileImg] = useState();

  const hiddenFileInput = useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const dispatch = useDispatch();

  const saveData = (cb) => {
    if (
      (!profileImg && !WeddingWeb?.background_image) ||
      !date ||
      !description
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 1,
          event_id: WeddingWeb?.event_id,
          date: moment(date?.$d).format("YYYY-MM-DD"),
          description,
          image: profileImg,
        })
      ).then(() => {
        if (cb) {
          cb();
        }
      });
    }
  };

  const onClickNext = () => {
    saveData(() => setCurrentStep((prev) => prev + 1));
  };
  const onClickSave = () => {
    saveData(() => setSave(true));
  };
  return (
    <>
      {!save ? (
        <div style={{ backgroundColor: "white" }}>
          <div className={styles.subCont}>
            <div className={styles.subContLeft}>
              <div className={styles.imageCont} onClick={handleClick}>
                <img
                  className={profileImg ? styles.profileImg : styles.img}
                  src={
                    profileImg
                      ? URL.createObjectURL(profileImg)
                      : WeddingWeb?.background_image
                      ? WeddingWeb?.background_image
                      : addImg
                  }
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setProfileImg(e.target.files[0])}
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                />
              </div>
            </div>
            <div className={styles.subContRight}>
              <div className={styles.content}>
                <div className={styles.usersImg}>
                  <div className={styles.userDetail}>
                    <div className={styles.images}>
                      <img
                        src={
                          WeddingWeb?.welcome?.bride?.image
                            ? WeddingWeb?.welcome?.bride?.image
                            : dummy
                        }
                        className={styles.pfImg}
                      />
                      <DotsIcon className={styles.dots} />
                    </div>
                    <TextComponent
                      text={WeddingWeb?.welcome?.bride?.name}
                      textClass={styles.name}
                    />
                    <TextComponent text={"Bride"} textClass={styles.role} />
                  </div>
                  <div className={styles.userDetail}>
                    <div className={styles.images}>
                      <img
                        src={
                          WeddingWeb?.welcome?.groom?.image
                            ? WeddingWeb?.welcome?.groom?.image
                            : dummy
                        }
                        className={styles.pfImg}
                      />
                      <DotsIcon className={styles.dots} />
                    </div>
                    <TextComponent
                      text={WeddingWeb?.welcome?.groom?.name}
                      textClass={styles.name}
                    />
                    <TextComponent text={"Groom"} textClass={styles.role} />
                  </div>
                </div>
                <DatePickerInput
                  placeholder={"Wedding Date"}
                  className={styles.datePicker}
                  value={date}
                  onChange={(e) => setdate(e)}
                  datePickerClass={styles.datePickerInput}
                />
                <TextareaField
                  value={description}
                  rows={1}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder={"Description"}
                  className={styles.input}
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <SubmitButton
                    btnClass={styles.btn}
                    title={"Save"}
                    onClick={onClickSave}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.submitBtn}>
            <SubmitButton
              btnClass={styles.nextBtn}
              title={"Next"}
              onClick={onClickNext}
            />
          </div>
        </div>
      ) : (
        <div className={styles.detailsCont}>
          <TextComponent text={"Congratulations"} textClass={styles.congTxt} />
          <div className={styles.dtlusersImg}>
            <div className={styles.dtluserDetail}>
              <div className={styles.images}>
                <img
                  src={
                    WeddingWeb?.welcome?.bride?.image
                      ? WeddingWeb?.welcome?.bride?.image
                      : dummy
                  }
                  className={styles.dtlpfImg}
                />
                <DotsIcon className={styles.dots} />
              </div>
              <TextComponent
                text={WeddingWeb?.welcome?.bride?.name}
                textClass={styles.dtlname}
              />
              {/* <TextComponent text={"Bride"} textClass={styles.role} /> */}
            </div>
            <div className={styles.dtluserDetail}>
              <div className={styles.images}>
                <img
                  src={
                    WeddingWeb?.welcome?.groom?.image
                      ? WeddingWeb?.welcome?.groom?.image
                      : dummy
                  }
                  className={styles.dtlpfImg}
                />
                <DotsIcon className={styles.dots} />
              </div>
              <TextComponent
                text={WeddingWeb?.welcome?.groom?.name}
                textClass={styles.dtlname}
              />
              {/* <TextComponent text={"Groom"} textClass={styles.role} /> */}
            </div>
          </div>
          <div className={styles.descriptionDiv}>
            <TextComponent
              textClass={styles.descriptionTxt}
              text={description}
              // textClass={styles.}
            />
          </div>
          <div className={styles.wedDate}>
            <TextComponent text={"Wedding Date"} />
            <TextComponent
              textClass={styles.wedDateTxt}
              text={moment(WeddingWeb.welcome.date).format("MMMM DD, yyyy")}
            />
          </div>
          <TextComponent
            text={"Edit"}
            textClass={styles.editBtn}
            // onClick={() => onClickEditBtn(item)}
            onClick={() => setSave(false)}
          />
          <div className={styles.submitBtn}>
            <SubmitButton
              btnClass={styles.nextBtn2}
              title={"Next"}
              onClick={() => setCurrentStep((prev) => prev + 1)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Screen1;
